// @ts-nocheck

export default {
  "l10n": {
    "date": {
      "months": {
        "full": ["janeiro","fevereiro","março","abril","maio","junho","julho","agosto","setembro","outubro","novembro","dezembro"],
        "abbr": ["jan.","fev.","mar.","abr.","mai.","jun.","jul.","ago.","set.","out.","nov.","dez."]
      },
      "days": {
        "full": ["domingo","segunda-feira","terça-feira","quarta-feira","quinta-feira","sexa-feira","sábado"],
        "abbr": ["dom.","seg.","ter.","qua.","qui.","sex.","sá."]
      },
      "patterns": {
        "longDate": "dddd, D MMMM YYYY",
        "dateSlash": "DD/MM/YYYY",
        "dateShort": "dddd D MMMM",
        "dateShortWithDay": "Do MMMM YYYY",
        "dateMedium": "dddd D MMMM - H[:]mm [h]",
        "dateMediumReversed" : "H[:]mm - D MMMM YYYY",
        "dateMediumSlash": "DD[/]MM[/]YYYY [a las] H[:]mm",
        "dateLarge": "dddd D MMMM [a las] HH[:]mm [h]",
        "timeShort": "LT",
        "timeMedium": "DD[/]MM [•] LT",
        "timeLarge": "DD[/]MM[/]YY [•] LT"
      }
    },
    "number": {
      "patterns": {
        "standard": ["-n", "n"],
        "amount": ["-nS", "nS"]
      },
      "group": {
        "separator": ".",
        "length": 3,
        "abbr": ["", "k", "M", "B"]
      },
      "decimal": {
        "separator": ",",
        "length": 2
      },
      "ordinal": function(number) { return number + (number === 1 ? '°' : '°'); }
    }
  },
  "translations": {
    "messages": {
  "!action:Bet": [
    null,
    "Apostar"
  ],
  "!action:GiftRace Start": [
    null,
    "Iniciar"
  ],
  "!action:Settings": [
    null,
    "Configurar"
  ],
  "!action:Share": [
    null,
    "Partilhar"
  ],
  "!action:deleteAndContinue": [
    null,
    "Apagar e continuar"
  ],
  "!action:viewMyNonValidatedBets": [
    null,
    "Ver as minhas apostas não validadas"
  ],
  "!desc:%1$s ES RM J-30 warning": [
    null,
    ""
  ],
  "!desc:ArjelAdvice": [
    null,
    "x"
  ],
  "!desc:ArjelLink": [
    null,
    "Interdiction volontaire de jeu"
  ],
  "!desc:ArjelTitle": [
    null,
    "Winamax est agréé par l'Autorité Nationale des Jeux"
  ],
  "!desc:BROptaWidgetWarning": [
    null,
    "Os resultados das apostas relativos a remates baseiam-se nas estatísticas oficiais do organizador e não nas estatísticas apresentadas acima."
  ],
  "!desc:BasketHowTo": [
    null,
    "Adicione seleções à sua aposta ao clicar nas cotas"
  ],
  "!desc:BetBuilderHelper": [
    null,
    "Com o MyMatch crie a sua aposta ao escolher varias seleções no mesmo jogo e obtenha a sua cota personalizada."
  ],
  "!desc:BetBuilderHelperBasketball": [
    null,
    "Com o MyMatch crie a sua aposta ao escolher varias seleções no mesmo jogo (vencedor da partida, número de pontos/ressaltos/assistências de um jogador) e obtenha a sua cota personalizada."
  ],
  "!desc:BetBuilderHelperSoccer": [
    null,
    "Com o MyMatch, crie a sua aposta ao escolher várias seleções no mesmo jogo (resultado ao intervalo, resultado exato final, número de golos, marcadores, …) e obtenha a sua cota personalizada."
  ],
  "!desc:BetshareWebsite": [
    null,
    "winamax.pt"
  ],
  "!desc:BzgaLegals": [
    null,
    "Eigentümer und Betreiber - Winamax SA - 136 B Rue de Grenelle, 75007 Paris, Frankreich\nGlücksspiel kann süchtig machen. Hilfe unter"
  ],
  "!desc:CashoutPendingRegulation": [
    null,
    "The Cashout amount is only paid out when all selections of the bet have been settled"
  ],
  "!desc:ClientUpdaterContent": [
    null,
    "Para atualizar o software, desinstale esta versão e faça download do novo software diretamente da App Store"
  ],
  "!desc:ClientUpdaterContentDeprecated": [
    null,
    "Esta versão não possui as ultimas atualizações e vai deixar de funcionar em breve"
  ],
  "!desc:DEBetTaxFreeDescription": [
    null,
    ""
  ],
  "!desc:DVTMLink": [
    null,
    "Verantwortliches Spiel"
  ],
  "!desc:DgojConfidentiality": [
    null,
    "Política de privacidad"
  ],
  "!desc:DgojLicence": [
    null,
    "\n        WINAMAX Sociedad Anónima (S.A.) cuya sede social se encuentra en 136bis Rue de Grenelle, 75007 París France.\n        Todos los derechos reservados.\n\n        WINAMAX se responsabiliza de este sitio web, al que la Dirección General de Ordenación del Juego le ha concedido las siguientes licencias: POQUER No/Ref: POQ/2018/001, APUESTAS DEPORTIVAS DE CONTRAPARTIDA No/Ref: ADC/2018/017\n\n        Está prohibida la participación de los menores de edad y los incapacitados legalmente o por resolución judicial.\n      "
  ],
  "!desc:DgojResponsibleGaming": [
    null,
    "Juego responsable"
  ],
  "!desc:DgojResponsibleGamingTextES": [
    null,
    "This is a real money gambling application. Please play responsibly and only bet what you can afford. For help and support with gambling addiction, please contact FEJAR at 900 533 025 or visit https://fejar.org/"
  ],
  "!desc:DgojTerms": [
    null,
    "Términos y condiciones"
  ],
  "!desc:DocumentTitle": [
    null,
    "Apostas desportivas | Winamax apostas desportivas | Apostas online"
  ],
  "!desc:DocumentTitleLive": [
    null,
    "Aposte em direto – Aposte nos desportos em direto com a Winamax"
  ],
  "!desc:FreebetHelper": [
    null,
    "As apostas gratuitas(freebets) são propostas em ofertas promocionais.\nCaso ganhe a aposta, apenas os ganhos líquidos (ganhos - aposta) serão creditados na sua conta."
  ],
  "!desc:GoalScorersHelper": [
    null,
    "Aposte no(a) jogador(a) que irá marcar pelo menos um golo ou então aposte precisamente no primeiro ou último marcador da partida. Estas apostas não consideram o prolongamento e eventuais grandes penalidades. Os autogolos não serão contabilizados. Se o primeiro (ou último) golo da partida for um autogolo, o jogador que marcar o golo seguinte (ou penúltimo golo) será considerado como o ou primeiro (ou último) marcador da partida."
  ],
  "!desc:HuntingAllStarsEnrollmentMainDescription": [
    null,
    "A caça começou!\nCompleta as 3 fases do jogo acumulando apostas vencedoras.\nColeciona os 3 coelhos all-star e vai para casa cheio de Freebets."
  ],
  "!desc:Minus18DE": [
    null,
    "Minderjährigen ist die Benutzung verboten"
  ],
  "!desc:MonopolyEnrollmentMessage": [
    null,
    "Completa as tuas coleções Monopoly graças as tuas apostas e ganha Freebets!"
  ],
  "!desc:PanicButtonConfirmation": [
    null,
    "You have activated a 24h break across all providers. You can play again earliest on tomorrow at %1$s."
  ],
  "!desc:PanicButtonConfirmationTitle": [
    null,
    "Your account is on a break"
  ],
  "!desc:RealityCheckMessage": [
    null,
    "Não te esqueças de fazer pausas regulares. Pode também encontrar mais informações na secção \"Proteção do jogador\" no nosso website."
  ],
  "!desc:ResponsibleGamingTextFR": [
    null,
    "This is a real-money gambling app. Please gamble responsibly and only bet what you can afford. For gambling addiction help and support, please contact (joueurs-info-service at 09-74-75-13-13or visit http://www.joueurs-info-service.fr/."
  ],
  "!desc:SoccerDecisivePlayer": [
    null,
    "Relativamente às apostas \"jogador decisivo\" e \"assistente\", as apostas serão canceladas se o jogador em questão não jogar. O resultado das apostas baseia-se nas estatísticas Opta.\nO jogador será decisivo no jogo, ou seja, irá marcar pelo menos um golo ou fazer pelo menos uma assistência (excluindo prolongamento e eventuais grandes penalidades)."
  ],
  "!desc:SoccerScorerDuo": [
    null,
    "Aposte no número de golos marcados pelos dois jogadores durante a partida (excluindo eventual prolongamento e marcação de grandes penalidades). A aposta será reembolsada caso um dos jogadores não jogue na parida."
  ],
  "!desc:SoccerScorerTrio": [
    null,
    "Aposte no número de golos marcados pelos três jogadores durante a partida (excluindo eventual prolongamento e marcação de grandes penalidades). A aposta será reembolsada caso um dos jogadores não jogue na partida."
  ],
  "!desc:SrijLicence": [
    null,
    "WINAMAX, S.A. Todos os direitos reservados. É uma empresa registada em Portugal com o número de empresa XXXXXXXXX, com sede na XXXXXXXX, em XXXXX e é titular das licenças de jogo n° XXX e XXX emitidas pelo SRIJ – Serviço de Regulação e Inspeção de Jogos que a autoriza a desenvolver a atividade de exploração de apostas desportivas à cota e de jogos de fortuna ou azar online em Portugal."
  ],
  "!desc:activateLineUpNotifications": [
    null,
    "Quer receber uma notificação quando são anunciadas as formações nos seus jogos favoritos?\nAtive as notificações nas suas preferências de comunicação"
  ],
  "!desc:userAlreadyOptedIn": [
    null,
    "Já está a participar nesta operação."
  ],
  "!noun:GridsCancelled": [
    null,
    "Canceladas"
  ],
  "!noun:GridsFilterCancelled": [
    null,
    "Canceladas"
  ],
  "!noun:GridsFilterLost": [
    null,
    "Perdidas"
  ],
  "!noun:GridsFilterRunning": [
    null,
    "A decorrer"
  ],
  "!noun:GridsFilterWon": [
    null,
    "Ganhas"
  ],
  "!noun:GridsFinancing": [
    null,
    "Financiamento a decorrer"
  ],
  "!noun:GridsFinished": [
    null,
    "Terminadas"
  ],
  "!noun:GridsLost": [
    null,
    "Perdidas"
  ],
  "!noun:GridsNotValidated": [
    null,
    "Não validadas"
  ],
  "!noun:GridsRunning": [
    null,
    "A decorrer"
  ],
  "!noun:GridsWon": [
    null,
    "Ganhas"
  ],
  "!noun:MonopolyWon": [
    "!noun:MonopolyWonPlural",
    ""
  ],
  "!noun:Rules": [
    null,
    "Regulamento"
  ],
  "!noun:Welcome": [
    null,
    "Bem-vindo!"
  ],
  "!noun:Won": [
    null,
    ""
  ],
  "!plural:Finished": [
    null,
    "Terminadas"
  ],
  "!plural:Won": [
    null,
    "Ganhas"
  ],
  "!scorer:Next": [
    null,
    "Seguinte"
  ],
  "!short:1st half - 2 or more": [
    null,
    "1ª parte - 2 ou mais"
  ],
  "!short:1st half - 3 or more": [
    null,
    "1ª parte - 3 ou mais"
  ],
  "!short:1st half - 4 or more": [
    null,
    "1ª parte - 4 ou mais"
  ],
  "!short:1st period - Scorer": [
    null,
    "1° período - Goleador"
  ],
  "!short:2 or more": [
    null,
    "2 ou mais"
  ],
  "!short:2nd half - 2 or more": [
    null,
    "2ª parte - 2 ou mais"
  ],
  "!short:2nd half - 3 or more": [
    null,
    "2ª parte - 3 ou mais"
  ],
  "!short:2nd half - 4 or more": [
    null,
    "2ª parte - 4 ou mais"
  ],
  "!short:2nd period - Scorer": [
    null,
    "2° período - Goleador"
  ],
  "!short:3 or more": [
    null,
    "3 ou mais"
  ],
  "!short:3rd period - Scorer": [
    null,
    "3° período - Goleador"
  ],
  "!short:4 or more": [
    null,
    "4 ou mais"
  ],
  "!short:AdditionnalTime": [
    null,
    "TE"
  ],
  "!short:Anytime goalscorer": [
    null,
    "Marcador"
  ],
  "!short:BothHalf": [
    null,
    "Ambas"
  ],
  "!short:Double": [
    null,
    "Bis"
  ],
  "!short:Draw": [
    null,
    "X"
  ],
  "!short:First": [
    null,
    "Primeiro"
  ],
  "!short:FirstHalf": [
    null,
    "1ª Parte"
  ],
  "!short:HalfTime": [
    null,
    "Int"
  ],
  "!short:Hat-trick": [
    null,
    "Hat trick"
  ],
  "!short:Last": [
    null,
    "Último"
  ],
  "!short:Next": [
    null,
    "Próximo"
  ],
  "!short:Overtime": [
    null,
    "Prol"
  ],
  "!short:Overtime - 2 or more": [
    null,
    "Prolongamento - 2 ou mais"
  ],
  "!short:PenaltyShootOut": [
    null,
    "Pen"
  ],
  "!short:Points": [
    null,
    "PTS"
  ],
  "!short:RegularTime": [
    null,
    "Temp Reg."
  ],
  "!short:ScorerConversion": [
    null,
    "T"
  ],
  "!short:ScorerDrop": [
    null,
    "D"
  ],
  "!short:ScorerPenalty": [
    null,
    "P"
  ],
  "!short:SecondHalf": [
    null,
    "2ª Parte"
  ],
  "!short:Today": [
    null,
    "Hoje"
  ],
  "!short:bet": [
    "!short:bets",
    "aposta",
    "apostas"
  ],
  "%1$s (multiple chance)": [
    null,
    "%1$s multiopção"
  ],
  "%1$s + %2$s": [
    null,
    "%1$s + %2$s"
  ],
  "%1$s Base": [
    "%1$s Bases",
    "%1$s Base",
    "%1$s Bases"
  ],
  "%1$s bet": [
    "%1$s bets",
    "%1$s aposta",
    "%1$s apostas"
  ],
  "%1$s bet added": [
    "%1$s bets added",
    "%1$s aposta adicionada",
    "%1$s apostas adicionadas"
  ],
  "%1$s bet could not be validated": [
    "%1$s bets could not be validated",
    "%1$s aposta não pode ser validada",
    "%1$s apostas não podem ser validadas "
  ],
  "%1$s bet selected": [
    "%1$s bets selected",
    "%1$s aposta selecionada ",
    "%1$s apostas selecionadas "
  ],
  "%1$s guarenteed ": [
    null,
    "%1$s garantidos"
  ],
  "%1$s internal error": [
    null,
    ""
  ],
  "%1$s or more": [
    null,
    "%1$s ou mais"
  ],
  "%1$s selection": [
    "%1$s selections",
    "%1$s seleção  ",
    "%1$s seleções"
  ],
  "%1$s selection could not be added": [
    "%1$s selections could not be added",
    "Não foi possível adicionar %1$s seleção",
    "Não foi possível adicionar %1$s seleções"
  ],
  "%1$s single bet": [
    "%1$s single bets",
    "%1$s aposta simples ",
    "%1$s apostas simples"
  ],
  "%1$s's bet": [
    null,
    "Aposta de %1$s"
  ],
  "%1$s-%2$s PSO": [
    null,
    "%1$s-%2$s pen."
  ],
  "%1$s-%2$s a.e.t.": [
    null,
    "%1$s-%2$s a.p"
  ],
  "%1$s-%2$s reg. time": [
    null,
    "%1$s-%2$s tempo reg."
  ],
  "%1$s:": [
    null,
    "%1$s:"
  ],
  "(1 to %1$s)": [
    null,
    "(1 a %1$s)"
  ],
  "+%1$s min": [
    null,
    "+%1$s min"
  ],
  "10th set": [
    null,
    "10º set"
  ],
  "12-grids": [
    null,
    "Grelhas de 12"
  ],
  "1st": [
    null,
    "1º"
  ],
  "1st half": [
    null,
    "1ª Parte"
  ],
  "1st innings": [
    null,
    "1° inning"
  ],
  "1st period": [
    null,
    "1º período"
  ],
  "1st quarter": [
    null,
    "1º quarto"
  ],
  "1st set": [
    null,
    "1º set"
  ],
  "2 or more": [
    null,
    "2 ou mais"
  ],
  "24-hour break": [
    null,
    "Pausa de 24 horas"
  ],
  "2nd": [
    null,
    "2º"
  ],
  "2nd half": [
    null,
    "2ª Parte"
  ],
  "2nd half - Multiple goalscorers": [
    null,
    "2ª parte – Marcador múltiplo"
  ],
  "2nd innings": [
    null,
    "2° inning"
  ],
  "2nd period": [
    null,
    "2º período"
  ],
  "2nd quarter": [
    null,
    "2º quarto"
  ],
  "2nd set": [
    null,
    "2º set"
  ],
  "3 or more": [
    null,
    "3 ou mais"
  ],
  "3rd": [
    null,
    "3º"
  ],
  "3rd innings": [
    null,
    "3° inning"
  ],
  "3rd period": [
    null,
    "3º período"
  ],
  "3rd quarter": [
    null,
    "3º quarto"
  ],
  "3rd set": [
    null,
    "3º set"
  ],
  "4 or more": [
    null,
    "4 ou mais"
  ],
  "4th innings": [
    null,
    "4° inning"
  ],
  "4th quarter": [
    null,
    "4º quarto"
  ],
  "4th set": [
    null,
    "4º set"
  ],
  "5th innings": [
    null,
    "5° inning"
  ],
  "5th set": [
    null,
    "5º set"
  ],
  "6th innings": [
    null,
    "6° inning"
  ],
  "6th set": [
    null,
    "6º set"
  ],
  "7-grids": [
    null,
    "Grelhas de 7"
  ],
  "7th innings": [
    null,
    "7° inning"
  ],
  "7th set": [
    null,
    "7º set"
  ],
  "8th innings": [
    null,
    "8° inning"
  ],
  "8th set": [
    null,
    "8º set"
  ],
  "9th innings": [
    null,
    "9° inning"
  ],
  "9th set": [
    null,
    "9º set"
  ],
  "A server issue has interrupted media playback.": [
    null,
    "Um problema de rede interrompeu a leitura do vídeo."
  ],
  "ALL-IN": [
    null,
    "ALL-IN"
  ],
  "Accept changes": [
    null,
    "Aceitar modificações"
  ],
  "Acces to media failed.": [
    null,
    "Acesso impossível ao conteúdo multimédia."
  ],
  "Accumulator": [
    null,
    "Múltipla"
  ],
  "Accumulator %1$s": [
    null,
    "Múltipla %1$s"
  ],
  "Add": [
    null,
    "Adicionar"
  ],
  "Add an In-Play selection to get a %1$s bonus": [
    null,
    "Adicione uma aposta ao vivo para obter um bónus de %1$s"
  ],
  "Add bet to basket": [
    null,
    "Adicionar a aposta à minha cesta"
  ],
  "Add one selection to get a %1$s bonus": [
    null,
    "Adicione uma aposta para obter um bónus de %1$s"
  ],
  "Additional buttons allow you to make variations of an existing grid.": [
    null,
    "Botões adicionais permitem-lhe fazer alterações a uma grelha existente."
  ],
  "Ajax Amsterdam": [
    null,
    "Ajax "
  ],
  "All": [
    null,
    "Todas"
  ],
  "All my grids": [
    null,
    "Todas as minhas grelhas"
  ],
  "All players": [
    null,
    "Todos os jogadores"
  ],
  "All possible accumulators %1$s with %2$s from %3$s others, or %4$s in total": [
    null,
    "Todas as múltiplas possíveis de %1$s com %2$s entre os %3$s outros, ou seja %4$s apostas no total "
  ],
  "All possible accumulators from the %1$s from amongst %2$s, or %3$s in total": [
    null,
    "Todas as múltiplas possíveis de %1$s entre os %2$s ou seja %3$s apostas no total"
  ],
  "All rules": [
    null,
    "Regulamento completo"
  ],
  "Amount": [
    null,
    "Valor"
  ],
  "Amount collected:": [
    null,
    "Montante recolhido:"
  ],
  "Amount shared out:": [
    null,
    "Montante distribuído:"
  ],
  "Amount to be carried forward:": [
    null,
    "Montante ainda disponível:"
  ],
  "An error as occurred.": [
    null,
    "Ocorreu um erro "
  ],
  "An error has occured": [
    null,
    "Ocorreu um erro"
  ],
  "An error occurred, please try again.": [
    null,
    "Ocorreu um erro. Por favor, tente novamente."
  ],
  "And remember,": [
    null,
    "E lembre-se,"
  ],
  "And you will unlock phase 2.": [
    null,
    ""
  ],
  "And you will unlock phase 3.": [
    null,
    ""
  ],
  "Anytime": [
    null,
    "marcador"
  ],
  "Assistman": [
    null,
    "Assistente"
  ],
  "Assists": [
    null,
    "Assistências"
  ],
  "Assists+rebounds": [
    null,
    "Assistências+ressaltos"
  ],
  "At least one of the two teams": [
    null,
    "Pelo menos uma das duas equipas"
  ],
  "At least one of your multi-chance selections has too many choices.": [
    null,
    "Pelo menos uma das suas seleções multichance apresenta demasiadas opções."
  ],
  "At least one of your selections is currently suspended": [
    null,
    "Pelo menos uma das suas seleções encontra-se suspensa de momento."
  ],
  "At least one of your selections is no longer available.": [
    null,
    "Pelo menos uma das suas seleções não se encontra disponível."
  ],
  "At least one of your selections is no longer available. Check your betslip.": [
    null,
    "Pelo menos uma das suas seleções não se encontra disponível. Verifique o seu boletim."
  ],
  "At least one of your selections is not eligible for MyMatch.": [
    null,
    "Pelo menos uma das suas seleções não é elegível para o MyMatch."
  ],
  "At least one of your selections is not eligible for MyMatch. Check your betslip.": [
    null,
    "Pelo menos uma das suas seleções não é elegível para o MyMatch. Verifique o seu boletim."
  ],
  "Atletico Madrid": [
    null,
    "Atlético de Madrid"
  ],
  "Author": [
    null,
    "Autor"
  ],
  "BOOM, easy game!": [
    null,
    "BOOM, fácil!"
  ],
  "Back": [
    null,
    "Voltar"
  ],
  "Back to grid creation": [
    null,
    "Voltar para a criaçao de grelha "
  ],
  "Back to sports betting": [
    null,
    "Voltar para as apostas desportivas"
  ],
  "Back to the grid of the day": [
    null,
    "Voltar para a grelha do dia"
  ],
  "Balance": [
    null,
    "Saldo"
  ],
  "Base": [
    null,
    "Base"
  ],
  "Bayern Munich": [
    null,
    "Bayern de Munique"
  ],
  "Best author (badge)": [
    null,
    "Melhor autor (badge)"
  ],
  "Best author (winnings)": [
    null,
    "Melhor autor (ganhos)"
  ],
  "Best bets": [
    null,
    "As melhores apostas"
  ],
  "Bet": [
    null,
    ""
  ],
  "Bet %1$s could not be redeemed, one or more selections are not eligible for Cashout": [
    null,
    "Não foi possível de vender a aposta %1$s pois uma ou mais seleções não são elegíveis para cash out"
  ],
  "Bet %1$s could not be redeemed, remaining bet is less than €0.10": [
    null,
    "Não foi possível de vender a aposta %1$s pois o valor apostado restante é inferior a 0,10€"
  ],
  "Bet %1$s could not be redeemed, the Cashout amount has changed": [
    null,
    "Não foi possível de vender a aposta %1$s pois o valor do Cashout foi alterado"
  ],
  "Bet confirmation": [
    null,
    "Confirmação da aposta"
  ],
  "Bet is limited to free bet": [
    null,
    "Aposta disponível apenas para free bets"
  ],
  "Bet is not eligible for %1$s": [
    null,
    ""
  ],
  "Bet is not eligible for %1$s because at least one match starts after the end of the game": [
    null,
    ""
  ],
  "Bet is not eligible for %1$s because system bets are not eligible": [
    null,
    ""
  ],
  "Bet is not eligible for %1$s because the game is not in progress": [
    null,
    ""
  ],
  "Bet is not eligible for %1$s because the match starts in over 48 hours": [
    null,
    ""
  ],
  "Bet is not eligible for %1$s because this version of the game has ended": [
    null,
    ""
  ],
  "Bet is not eligible for %1$s because you have a reward to collect in order to unlock the next gift": [
    null,
    ""
  ],
  "Bet is not eligible for %1$s because you have already placed an eligible bet on the same match": [
    null,
    ""
  ],
  "Bet is not eligible for %1$s because you have already won the gift": [
    null,
    ""
  ],
  "Bet is not eligible for %1$s because you have not started the game": [
    null,
    ""
  ],
  "Bet is not eligible for %1$s because you must start the gift quest again": [
    null,
    ""
  ],
  "Bet is not eligible for %1$s because your current bets will be decisive": [
    null,
    ""
  ],
  "Bet is not eligible for Boom %1$s": [
    null,
    "A aposta não é elegível para o Boom %1$s"
  ],
  "Bet is not eligible for Boom %1$s because at least one match starts after the end of the game": [
    null,
    "A aposta não é elegível para o Boom %1$s porque pelo menos uma partida começa após o final do jogo"
  ],
  "Bet is not eligible for Boom %1$s because system bets are not eligible": [
    null,
    "A aposta não é elegível para o Boom %1$s porque as apostas sistema não são elegíveis"
  ],
  "Bet is not eligible for Boom %1$s because the game is not in progress": [
    null,
    "A aposta não é elegível para o Boom %1$s porque o jogo não está a decorrer"
  ],
  "Bet is not eligible for Boom %1$s because the match starts in over 48 hours": [
    null,
    "A aposta não é elegível para o Boom %1$s porque a partida começa dentro de 48 horas"
  ],
  "Bet is not eligible for Boom %1$s because you have a bet in the validation process": [
    null,
    "A aposta não é elegível para o Boom %1$s porque tem outra aposta em curso"
  ],
  "Bet is not eligible for Boom %1$s because you have already placed an eligible bet on the same match": [
    null,
    "A aposta não é elegível para o Boom %1$s porque já efetuou uma aposta elegível na mesma partida"
  ],
  "Bet is not eligible for Boom %1$s because you have not started the game": [
    null,
    "A aposta não é elegível para o Boom %1$s porque ainda não começou o jogo"
  ],
  "Bet is not eligible for Monopoly": [
    null,
    "A aposta não é elegível para o Monopoly"
  ],
  "Bet is not eligible for Monopoly because at least one match starts after the end of the game": [
    null,
    "A aposta não é elegível para o Monopoly porque pelo menos uma partida começa após o final do jogo"
  ],
  "Bet is not eligible for Monopoly because system bets are not eligible": [
    null,
    "A aposta não é elegível para o Monopoly porque as apostas sistema não são elegíveis"
  ],
  "Bet is not eligible for Monopoly because the game is not in progress": [
    null,
    "A aposta não é elegível para o Monopoly porque o jogo não está a decorrer"
  ],
  "Bet is not eligible for Monopoly because the match starts in over 48 hours": [
    null,
    "A aposta não é elegível para o Monopoly porque a partida começa dentro de 48 horas"
  ],
  "Bet is not eligible for Monopoly because you have already placed an eligible bet on the same match": [
    null,
    "A aposta não é elegível para o Monopoly porque já efetuou uma aposta elegível na mesma partida"
  ],
  "Bet is not eligible for Monopoly because you have not started the game": [
    null,
    "A aposta não é elegível para o Monopoly porque ainda não começou o jogo"
  ],
  "Bet modification unavailable": [
    null,
    "Modificação não disponível"
  ],
  "Bet modification unavailable with free bets": [
    null,
    "Modificação não disponível"
  ],
  "Bet pending": [
    null,
    "Aposta pendente"
  ],
  "Bet refused": [
    null,
    "Aposta recusada"
  ],
  "Bet stopped": [
    null,
    "Aposta terminada"
  ],
  "Bet suspended": [
    null,
    "Aposta suspensa"
  ],
  "Bet tax free": [
    null,
    ""
  ],
  "Bet validated": [
    null,
    "Aposta validada"
  ],
  "Bet validated!": [
    null,
    "Aposta validada !"
  ],
  "Bet validation in progress": [
    null,
    "A validar aposta"
  ],
  "Bets on the competition": [
    null,
    "Apostas na competição"
  ],
  "Betslip": [
    null,
    "Carrinho"
  ],
  "Betting with Winamax": [
    null,
    "Aposte online com a Winamax"
  ],
  "Biggest accumulators": [
    null,
    "As melhores combinadas"
  ],
  "Biggest winnings": [
    null,
    "Os maiores ganhos"
  ],
  "Blocks": [
    null,
    "Blocks"
  ],
  "Boom %1$s internal error": [
    null,
    "Erro interno Boom %1$s"
  ],
  "Boom St Valentine": [
    null,
    "Boom St Valentine"
  ],
  "Borussia M'Gladbach": [
    null,
    "Borussia M'Gladbach"
  ],
  "Both teams": [
    null,
    "Ambas as equipas"
  ],
  "Bracket": [
    null,
    "Quadricula  "
  ],
  "Bravo!": [
    null,
    "Parabéns!"
  ],
  "By ticking this box, your grid will be made private.": [
    null,
    "Ao clicar nesta caixa, a sua grelha será privada."
  ],
  "Cancelled": [
    null,
    "Anulada"
  ],
  "Cashout": [
    null,
    "Cashout"
  ],
  "Cashout (max %1$s)": [
    null,
    "Cashout (max %1$s)"
  ],
  "Cashout validated": [
    null,
    "Cashout validado"
  ],
  "Cashout validation in progress": [
    null,
    "Cashout em processo de validação"
  ],
  "Cashout €%1$s": [
    null,
    "Cashout %1$s €"
  ],
  "Cashout: %2$s available": [
    "Cashout: %2$s available",
    "%2$s disponível",
    "%2$s disponíveis"
  ],
  "Certain data may not be up to date.": [
    null,
    "Certos dados poderão estar desatualizados."
  ],
  "Check out the public grids as well as information about the authors of these grids and find the one that suits you best.": [
    null,
    "Consulte as grelhas públicas bem como as informações acerca dos autores destas e descubra qual a melhor lhe convém."
  ],
  "Check the full rules": [
    null,
    ""
  ],
  "Choose the amount of your stake on this grid as a team.": [
    null,
    "Escolha a sua parte da grelha em equipa."
  ],
  "Choose your format (7 or 12 matches) and validate your own grid.": [
    null,
    "Escolha o seu formato (7 ou 12 grelhas) e valide a sua própria grelha. "
  ],
  "Christmas is already over!": [
    null,
    ""
  ],
  "Claim": [
    null,
    ""
  ],
  "Click and hold an image to save or share": [
    null,
    "Clique continuamente na imagem para a guardar ou partilhar."
  ],
  "Close": [
    null,
    "Fechar"
  ],
  "Close details": [
    null,
    "Fechar detalhes"
  ],
  "Combinations": [
    null,
    "Combinações"
  ],
  "Combo booster": [
    null,
    "Combo booster"
  ],
  "Compact grid": [
    null,
    "Grelha compacta"
  ],
  "Compact view": [
    null,
    "Vista compacta"
  ],
  "Competitions": [
    null,
    "Competições"
  ],
  "Complete all 3 phases of the game by placing winning bets and walk away with legendary gifts and lots of Freebets:": [
    null,
    "completar as três fases do jogo, ao realizar apostas vencedoras e ganhe prémios lendários e muitas freebets:"
  ],
  "Complete bet": [
    null,
    "Completar a minha aposta"
  ],
  "Confirm": [
    null,
    "Validar"
  ],
  "Congratulations on your journey!": [
    null,
    "Parabéns pelo teu percurso!"
  ],
  "Congratulations!": [
    null,
    "Parabéns!"
  ],
  "Connection error.": [
    null,
    "Ocorreu um erro durante a ligação."
  ],
  "Contradictory selections": [
    null,
    "Seleções contraditórias"
  ],
  "Contradictory selections.": [
    null,
    "As seleções são contraditórias."
  ],
  "Contradictory selections. Check your betslip.": [
    null,
    "As seleções são contraditórias. Verifique o seu boletim."
  ],
  "Copied": [
    null,
    "Copiadas"
  ],
  "Copy": [
    null,
    "Copiar"
  ],
  "Copy the link": [
    null,
    "Copiar o link"
  ],
  "Countries": [
    null,
    "Países"
  ],
  "Dead-Heat": [
    null,
    "Caso de empate"
  ],
  "Decisive": [
    null,
    "Decisivo"
  ],
  "Decisive players": [
    null,
    "Jogadores decisivos"
  ],
  "Delete grid": [
    null,
    "Eliminar grelha"
  ],
  "Delete my favourites": [
    null,
    "Apagar favoritos"
  ],
  "Detailed grids": [
    null,
    "Grelhas detalhadas"
  ],
  "Didn't understand everything on the previous screen?": [
    null,
    "Não entendeu algo no ecrã anterior?"
  ],
  "Direct free kick": [
    null,
    "Livre direto"
  ],
  "Display sliders on relevant bets by default": [
    null,
    "Exibir cursores nas apostas relevantes por predefinição"
  ],
  "Do you like this application?": [
    null,
    "Gosta desta aplicação?"
  ],
  "Do you want to keep a low profile and only share your grid with your friends? Opt for the private grid.": [
    null,
    "Prefere ser discreto e partilhar a sua grelha apenas com os seus amigos? Opte pot uma grelha privada."
  ],
  "Do you wish to comment on this application?": [
    null,
    "Gostaria de fazer um comentário acerca desta aplicação?"
  ],
  "Don't save bet": [
    null,
    "Não guardar mais a aposta"
  ],
  "Double-double": [
    null,
    "Duplo-duplo"
  ],
  "Draw": [
    null,
    "Empate"
  ],
  "Duplicate grid": [
    null,
    "Duplicar grelha"
  ],
  "Each simple bet is placed individually": [
    null,
    "Cada aposta simples é feita individualmente"
  ],
  "Edit": [
    null,
    "Editar"
  ],
  "Enhance": [
    null,
    "Completar"
  ],
  "Error whilst crediting your reward": [
    null,
    ""
  ],
  "Error, please try again": [
    null,
    "Erro. Por favor, tente novamente"
  ],
  "Event abandoned": [
    null,
    "Evento abandonado"
  ],
  "Event cancelled": [
    null,
    "Evento anulado"
  ],
  "Event ended": [
    null,
    "Evento terminado"
  ],
  "Event postponed": [
    null,
    "Evento adiado"
  ],
  "Eventual winnings will be shared in proportion to each player's stake.": [
    null,
    "Ganhos eventuais serão partilhados em proporção com a participação de cada jogador."
  ],
  "Excluding extra-time and penalty shoot-out.": [
    null,
    "Excluindo eventual prolongamento e marcação de grandes penalidades."
  ],
  "Explode Cupid by winnings 5 bets": [
    null,
    "Explodir o cupido ao ganhar 5 apostas"
  ],
  "Explode the leprechaun by winnings 5 bets": [
    null,
    "Explodir o duende ao ganhar 5 apostas"
  ],
  "Explode your pumpkin by winnings 5 bets": [
    null,
    "Explodir a tua abóbora ao ganhar 5 apostas"
  ],
  "Extras": [
    null,
    "Promos"
  ],
  "FC Porto": [
    null,
    "FC Porto"
  ],
  "Filter bets": [
    null,
    "Filtrar apostas"
  ],
  "Finance your entire grid or share the jackpot by playing as a team.": [
    null,
    "Financie a totalidade da sua grelha ou partilhe o jackpot ao jogar em equipa."
  ],
  "Find out how much you've pocketed as soon as the last game of your grid ends.": [
    null,
    "Descubra quanto amealhou assim que a última partida da sua grelha terminar."
  ],
  "First": [
    null,
    "primeiro"
  ],
  "Flash": [
    null,
    "Flash"
  ],
  "Follow the live results and stats of your grids.": [
    null,
    "Siga os resultados ao vivo e estatísticas das suas grelhas."
  ],
  "For a 24h break hold the button pressed for 3 seconds.": [
    null,
    "Para fazer uma pausa de 24horas, mantenha o botão pressionado durante 3 segundos. "
  ],
  "Format change": [
    null,
    "Alteração do formato"
  ],
  "Frame %1$s": [
    null,
    "Frame %1$s"
  ],
  "Freebet Wager": [
    null,
    "Aposta Freebets"
  ],
  "Freebet win for the complete colour collection: Reference bet x %1$s": [
    null,
    "Ganhos de Freebets pela coleção completa: Aposta de referência x %1$s"
  ],
  "Freebet winnings if you win this level: Reference bet x %1$s": [
    null,
    "Ganhos em Freebets se ganhar este nível: Aposta de referência x %1$s"
  ],
  "Freebets Wager": [
    null,
    "Aposta Freebets"
  ],
  "Game objective": [
    null,
    "Objetivo"
  ],
  "Gather properties, complete colour collections and win lots of Freebets!": [
    null,
    "Colecione propriedades, complete as coleções e ganhe o máximo de Freebets!"
  ],
  "General problem": [
    null,
    "Problema geral"
  ],
  "Get started": [
    null,
    "Começar"
  ],
  "Gift Race": [
    null,
    ""
  ],
  "Goalscorer Duo": [
    null,
    "Dupla de Marcadores"
  ],
  "Goalscorer Guarantee": [
    null,
    "Garantia Marcador"
  ],
  "Goalscorer Trio": [
    null,
    "Trio de Marcadores"
  ],
  "Goalscorer in a period": [
    null,
    "Marcador durante um dos períodos"
  ],
  "Goalscorers in a 10 min period": [
    null,
    "Marcador num período de 10 minutos"
  ],
  "Goalscorers in a 15 min period": [
    null,
    "Marcador num período de 15 minutos"
  ],
  "Graphics preferences": [
    null,
    "Preferências gráficas"
  ],
  "Grid": [
    null,
    "Grelha"
  ],
  "Grid %1$s winnings": [
    null,
    "Ganhos da %1$s grelha "
  ],
  "Grid price": [
    null,
    "Preço grelha"
  ],
  "Grid result": [
    null,
    "Resultado da grelha"
  ],
  "Grids": [
    null,
    "Grelhas"
  ],
  "Grids Home": [
    null,
    "Home Grelhas"
  ],
  "Guarantee:": [
    null,
    "Grarantido:"
  ],
  "Half time - Multiple goalscorers": [
    null,
    "1ª parte – Marcador múltiplo"
  ],
  "Half-time goalscorers": [
    null,
    "Marcador numa parte"
  ],
  "Halloween": [
    null,
    "Halloween"
  ],
  "Header": [
    null,
    "Cabeceamento"
  ],
  "Hidden": [
    null,
    "Ocultas"
  ],
  "Hide bet": [
    null,
    "Ocultar aposta"
  ],
  "Highest MyMatch odds": [
    null,
    "As melhores cotas MyMatch"
  ],
  "Highest odds": [
    null,
    "As melhores cotas"
  ],
  "Home": [
    null,
    "Home"
  ],
  "Hunting": [
    null,
    "Hunting"
  ],
  "Hunting All-Stars": [
    null,
    ""
  ],
  "If you lose a bet, you start the phase from 0.": [
    null,
    ""
  ],
  "Important account information": [
    null,
    "Informações referentes à sua conta"
  ],
  "In Play": [
    null,
    "Live"
  ],
  "In progress": [
    null,
    ""
  ],
  "Incorrect PIN": [
    null,
    "PIN incorreto"
  ],
  "Incorrect amount": [
    null,
    "Valor incorreto"
  ],
  "Incorrect email, password or date of birth": [
    null,
    "Email, palavra-passe ou data de nascimento incorretos"
  ],
  "Individual grid": [
    null,
    "Grelha individual"
  ],
  "Inter Milan": [
    null,
    "Inter de Milão"
  ],
  "Internal error": [
    null,
    "Erro interno"
  ],
  "It's not the grids that matter, it's what you do with them!": [
    null,
    "Não são as grelhas que importam, mas o que pode fazer com elas!"
  ],
  "It's simple! Select a result of your choice (team 1 or team 2 or draw) for each match.": [
    null,
    "É simples! Escolha um resultado (equipa 1, equipa 2 ou empate) para cada partida."
  ],
  "Koh-Lanta": [
    null,
    ""
  ],
  "Lacking inspiration? You can also take part in a public grid.": [
    null,
    "Falta de inspiração? Pode participar numa grelha publica."
  ],
  "Last": [
    null,
    "Último"
  ],
  "Later": [
    null,
    "Later"
  ],
  "Least expensive": [
    null,
    "Mais baratas"
  ],
  "Less selections": [
    null,
    "Menos seleções"
  ],
  "Level %1$s": [
    null,
    "Nível %1$s"
  ],
  "Line %1$s": [
    null,
    "Linha %1$s"
  ],
  "Link copied!": [
    null,
    "Link copiado!"
  ],
  "Live": [
    null,
    "Em direto"
  ],
  "Liverpool": [
    null,
    "Liverpool"
  ],
  "Loading": [
    null,
    "Carregamento "
  ],
  "Loading in progress": [
    null,
    "A carregar…"
  ],
  "Log in": [
    null,
    "Log In"
  ],
  "Log in to %1$s": [
    null,
    "Log in em %1$s"
  ],
  "Lost": [
    null,
    "Perdida"
  ],
  "Maintenance in progress": [
    null,
    "Manutenção a decorrer"
  ],
  "Maintenance in progress.": [
    null,
    "Manutenção em curso"
  ],
  "Manchester City": [
    null,
    "Manchester City"
  ],
  "Manchester United": [
    null,
    "Manchester United"
  ],
  "Map %1$s": [
    null,
    "Mapa %1$s"
  ],
  "Marseille": [
    null,
    "Marselha"
  ],
  "Match": [
    null,
    "Partida"
  ],
  "Match details": [
    null,
    "Detalhes das partidas"
  ],
  "Match details and odds": [
    null,
    "Infos e cotas da partida"
  ],
  "Match ended": [
    null,
    "Jogo terminado"
  ],
  "Match odds": [
    null,
    "As cotas do jogo"
  ],
  "Match result odds": [
    null,
    "Cota do resultdo da partida"
  ],
  "Match unavailable": [
    null,
    "Partida indisponível"
  ],
  "Matches": [
    null,
    "Partidas"
  ],
  "Maximum selections reached": [
    null,
    "Número máximo de seleções atingido"
  ],
  "Min. odds": [
    null,
    "Cota mín."
  ],
  "Min. odds:": [
    null,
    "Cota mín.:"
  ],
  "Min. wager:": [
    null,
    "Aposta mín.:"
  ],
  "Minimum odds to win this card: %1$s": [
    null,
    "Cota mínima para obter esta carta: %1$s"
  ],
  "Minimum odds to win this level: %1$s": [
    null,
    "Cota mínima para obter esta nível : %1$s"
  ],
  "Monopoly internal error": [
    null,
    "Erro interno Monopoly"
  ],
  "More selections": [
    null,
    "Mais seleções"
  ],
  "Most advanced": [
    null,
    "Mais avancadas"
  ],
  "Most expensive": [
    null,
    "Mais caras"
  ],
  "Most popular": [
    null,
    "Mais populares"
  ],
  "Most recent": [
    null,
    "Mais recentes"
  ],
  "Multiples:": [
    null,
    "Múltiplas:"
  ],
  "Multiscorers": [
    null,
    "Múltiplos marcadores"
  ],
  "My bets": [
    null,
    "As minhas apostas"
  ],
  "My collection": [
    null,
    "A minha coleção"
  ],
  "My favourites": [
    null,
    "Favoritos"
  ],
  "My grids": [
    null,
    "As minhas grelhas"
  ],
  "My wager": [
    null,
    "A minha aposta"
  ],
  "My winnings": [
    null,
    "Os meus ganhos"
  ],
  "MyMatch currently unavailable": [
    null,
    "MyMatch indisponível de momento."
  ],
  "MyMatch mode": [
    null,
    "Modo MyMatch"
  ],
  "MyMatch unavailable": [
    null,
    "MyMatch indisponível"
  ],
  "News": [
    null,
    "News"
  ],
  "Next": [
    null,
    "Seguinte"
  ],
  "Next grid": [
    null,
    "Próxima grelha"
  ],
  "Next grids": [
    null,
    "Próximas grelhas"
  ],
  "No": [
    null,
    "Não"
  ],
  "No bets": [
    null,
    "Sem apostas"
  ],
  "No grid": [
    null,
    "Sem grelhas"
  ],
  "No grid played": [
    null,
    "Sem grelhas jogadas"
  ],
  "No grids": [
    null,
    "Sem grelhas"
  ],
  "No grids cancelled": [
    null,
    "Sem grelhas canceladas"
  ],
  "No grids lost": [
    null,
    "Sem grelhas perdidas"
  ],
  "No grids running": [
    null,
    "Sem grelhas a decorrer"
  ],
  "No grids won": [
    null,
    "Sem grelhas ganhas"
  ],
  "No public grids": [
    null,
    "Sem grelhas públicas"
  ],
  "No rank 1 winners": [
    null,
    "Sem vencedores de nível 1"
  ],
  "No results": [
    null,
    "Sem resultados"
  ],
  "No team": [
    null,
    "Nenhuma das equipas"
  ],
  "Non-top 10 competitor": [
    null,
    "Concorrente fora do Top 10"
  ],
  "Non-top 30 competitor": [
    null,
    "Concorrente fora do Top 30"
  ],
  "Not enough combinations": [
    null,
    "Combinações insuficientes"
  ],
  "Notifications": [
    null,
    "Notificações"
  ],
  "Number": [
    null,
    "Número"
  ],
  "Number of bets": [
    null,
    "Número de apostas"
  ],
  "Number of goals from the player": [
    null,
    "Total de golos do jogador"
  ],
  "Odds": [
    null,
    "Cota"
  ],
  "Odds equal or inferior to 1": [
    null,
    "Cota igual ou inferior a 1"
  ],
  "Odds:": [
    null,
    "Cota:"
  ],
  "Official lineups": [
    null,
    "Escalações oficiais"
  ],
  "Official starting lineups": [
    null,
    "5 inicial oficial"
  ],
  "Ok": [
    null,
    "Ok"
  ],
  "Olympiakos": [
    null,
    "Olympiakos"
  ],
  "One or multiple selections are unavailable": [
    null,
    "Uma ou mais seleções não estão disponíveis"
  ],
  "Ongoing": [
    null,
    "A decorrer"
  ],
  "Oops,": [
    null,
    "Ups!"
  ],
  "Open the App Store": [
    null,
    "Abrir a App Store"
  ],
  "PRA": [
    null,
    "PRA"
  ],
  "Paris SG": [
    null,
    "Paris SG"
  ],
  "Penalty": [
    null,
    "Penálti"
  ],
  "Penalty try": [
    null,
    "Ensaio de penalidade"
  ],
  "Pending %1$s bets": [
    null,
    "%1$s apostas pendentes "
  ],
  "Pending bet refused": [
    null,
    "Aposta pendente recusada"
  ],
  "Pending bet validated": [
    null,
    "Aposta pendente para validação "
  ],
  "Permanent and past promotions": [
    null,
    "Ofertas permanentes e passadas"
  ],
  "Phase 1: Pegasus Shoes": [
    null,
    ""
  ],
  "Phase 2: The remote control ball": [
    null,
    ""
  ],
  "Phase 3: The Chameleon Jersey": [
    null,
    ""
  ],
  "Place a series of winning bets to score %1$s points.": [
    null,
    ""
  ],
  "Play the game to try and win a ton of Freebets!": [
    null,
    "Participa no jogo para tentar\nganhar o maior número possível de Freebets!"
  ],
  "Player": [
    null,
    "Jogador"
  ],
  "Player vs. player": [
    null,
    "Jogador contra jogador"
  ],
  "Player vs. team": [
    null,
    "Jogador contra equipa"
  ],
  "Please enter a valid amount.": [
    null,
    "Por favor, introduza um montante válido."
  ],
  "Please enter your date of birth": [
    null,
    "Introduza a sua data de nascimento"
  ],
  "Points": [
    null,
    "Pontos"
  ],
  "Points structure: 100 x product (winning odds). Thus, if your first 3 bets are winners, you win 100 x odds1 x odds2 x odds3 points.": [
    null,
    "Tabela de pontos: 100 x produto (cotas vencedoras). Assim, se as tuas 3 primeiras apostas forem vencedoras, ganharás 100 x cota1 x cota2 x cota3 pontos."
  ],
  "Points+assists": [
    null,
    "Pontos+Assistências"
  ],
  "Points+rebounds": [
    null,
    "Pontos+ressaltos"
  ],
  "Poker": [
    null,
    "Poker"
  ],
  "Potential winnings": [
    null,
    "Ganhos potenciais"
  ],
  "Previous": [
    null,
    "Anterior"
  ],
  "Prize distribution per player": [
    null,
    "Distribuição de prémios por jogador "
  ],
  "Prizepool": [
    null,
    "Prizepool"
  ],
  "Probable starting lineups": [
    null,
    "5 inicial provável"
  ],
  "Prohibited": [
    null,
    "Interdito"
  ],
  "Prohibited (no-stakes game)": [
    null,
    "Interdito (partida sem incentivo)"
  ],
  "Projected lineups": [
    null,
    "Prováveis ​​escalações"
  ],
  "Provisional grid result": [
    null,
    "Resultado provisório de grelha"
  ],
  "Provisional prize distribution": [
    null,
    "Distribuição de prémios provisória"
  ],
  "Public grid": [
    null,
    "Grelha pública"
  ],
  "Public grids": [
    null,
    "Grelhas públicas"
  ],
  "Real Madrid": [
    null,
    "Real Madrid"
  ],
  "Rebounds": [
    null,
    "Ressaltos"
  ],
  "Ref:": [
    null,
    "Ref:"
  ],
  "Reference": [
    null,
    "Referência"
  ],
  "Reference bet: the smallest bet of the levels you have won (max %1$s)": [
    null,
    "Aposta de referência: a aposta mais pequena dos níveis ganhos (máx. %1$s)"
  ],
  "Refuse": [
    null,
    "Recusar"
  ],
  "Refused": [
    null,
    "Recusada"
  ],
  "Repeat this bet": [
    null,
    "Retomar esta aposta"
  ],
  "Reset": [
    null,
    "Reiniciar"
  ],
  "Reset the grid": [
    null,
    "Reiniciar a grelha"
  ],
  "Result": [
    null,
    "Resultado"
  ],
  "Retired or defaulted": [
    null,
    "Abandono ou desqualificação"
  ],
  "Reviews": [
    null,
    "Avaliações"
  ],
  "Right-click an image to copy it or to save it on your device": [
    null,
    "Clique com o botão direito na imagem para a copiar ou guardar no seu dispositivo."
  ],
  "Rules": [
    null,
    "Regulamento"
  ],
  "Running": [
    null,
    "A decorrer"
  ],
  "Save bet": [
    null,
    "Guardar aposta"
  ],
  "Save my selection": [
    "Save my selections",
    "Guardar a minha seleção",
    "Guardar as minhas seleções"
  ],
  "Saved": [
    null,
    "Guardadas"
  ],
  "Scan a bonus code": [
    null,
    "Ler um código de bónus"
  ],
  "Scorer": [
    null,
    "Marcador"
  ],
  "Scorer type": [
    null,
    "Tipo de golo do jogador"
  ],
  "Scorers": [
    null,
    "Marcadores"
  ],
  "Search": [
    null,
    "Procurar"
  ],
  "See all": [
    null,
    "Ver tudo"
  ],
  "See all odds": [
    null,
    "Ver todas as cotas"
  ],
  "See details": [
    null,
    "Detalhes "
  ],
  "See more selections": [
    null,
    "Ver mais seleções"
  ],
  "See top matches": [
    null,
    "Ver partidas Top"
  ],
  "Select": [
    null,
    "Selecionar"
  ],
  "Service unavailable": [
    null,
    "Serviço indisponível"
  ],
  "Settings": [
    null,
    "Parâmetros"
  ],
  "Shaktar Donetsk": [
    null,
    "Shaktar Donetsk"
  ],
  "Share bet to a friend's basket": [
    null,
    "Partilhar a aposta para a cesta de um amigo"
  ],
  "Share image": [
    null,
    "Partilhar a imagem"
  ],
  "Share my bet": [
    null,
    "Partilhar a minha aposta"
  ],
  "Share options": [
    null,
    "Opções de partilhar"
  ],
  "Shop": [
    null,
    "Shop"
  ],
  "Show animation when adding a selection to betslip": [
    null,
    "Exibir animação ao adicionar seleção ao carrinh"
  ],
  "Show bet": [
    null,
    "Não ocultar mais a aposta"
  ],
  "Show username": [
    null,
    "Mostrar username"
  ],
  "Show wager and winnings": [
    null,
    "Mostrar aposta e os ganhos"
  ],
  "Sign-in": [
    null,
    "Conectar"
  ],
  "Sign-in and place bet": [
    null,
    "Conecte-se e aposte"
  ],
  "Sign-up": [
    null,
    "Inscrever-se"
  ],
  "Simple touchdown scorer": [
    null,
    "Marcador"
  ],
  "Single": [
    null,
    "Simples"
  ],
  "Skip all": [
    null,
    "Saltar tudo"
  ],
  "Sports": [
    null,
    "Desportos"
  ],
  "Sports bets": [
    null,
    "Apostas desportivas"
  ],
  "St Patrick": [
    null,
    "St Patrick"
  ],
  "St Valentine": [
    null,
    "St Valentine"
  ],
  "Start": [
    null,
    "Iniciar"
  ],
  "Start again": [
    null,
    ""
  ],
  "Starter": [
    null,
    "Titular"
  ],
  "Starters": [
    null,
    "Titulares"
  ],
  "Starting 5 Guarantee": [
    null,
    "Garantia Basquetebol"
  ],
  "Stats": [
    null,
    "Estatísticas"
  ],
  "Steals": [
    null,
    "Steals"
  ],
  "Steals+blocks": [
    null,
    "Steals+blocks"
  ],
  "Substitutes": [
    null,
    "Suplentes"
  ],
  "System": [
    null,
    "Sistema"
  ],
  "System %1$s": [
    null,
    "Sistema %1$s"
  ],
  "System %1$s/%2$s": [
    null,
    "Sistema %1$s/%2$s"
  ],
  "System bet": [
    null,
    "Aposta sistema"
  ],
  "System grid": [
    null,
    "Grelha em sistema"
  ],
  "System grid price": [
    null,
    "Preço de grelha em sistema"
  ],
  "Take part": [
    null,
    "Participar"
  ],
  "Team 1": [
    null,
    "Equipa 1"
  ],
  "Team 2": [
    null,
    "Equipa 2"
  ],
  "Team grid": [
    null,
    "Grelha em equipa"
  ],
  "Terms and Conditions and Privacy Policy": [
    null,
    "Termos e Condições e Política de Privacidade "
  ],
  "The Gift Race": [
    null,
    ""
  ],
  "The Pegasus shoes to fly over your next match": [
    null,
    "As sandálias de Pegasus para voar por cima do seu próximo jogo"
  ],
  "The bet is not eligible for Boom %1$s because Freebets are not taken into account": [
    null,
    "A aposta não é elegível para o Boom %1$s porque as Freebets não são tidas em conta"
  ],
  "The bet is not eligible for Monopoly because Freebets are not taken into account": [
    null,
    "As apostas realizadas com Freebets não são elegíveis para a promoção Monopoly"
  ],
  "The chameleon jersey to change teams in a flash": [
    null,
    "A camisola-camaleão para trocar de equipa num instante"
  ],
  "The classic accumulator wins if the %1$s are correct": [
    null,
    "A múltipla clássica, ganha se acertar as %1$s"
  ],
  "The date of birth entered does not match the date registered on your account": [
    null,
    "A data de nascimento introduzida não corresponde à data registada na sua conta"
  ],
  "The date of birth you have entered is invalid": [
    null,
    "A data de nascimento que introduziu é inválida "
  ],
  "The game is over": [
    null,
    ""
  ],
  "The game will end in under 24 hours": [
    null,
    "O jogo irá terminar em menos de 24 horas"
  ],
  "The hunt is over": [
    null,
    "A caça terminou"
  ],
  "The maximum stake for this bet has already been reached, or the stake is lower than the minimum of €0.10": [
    null,
    "O valor máximo para esta aposta foi atingido, ou o valor é inferior ao valor mínimo (0,10 €)"
  ],
  "The maximum wager is %1$s": [
    null,
    "A aposta máxima é %1$s"
  ],
  "The minimum odds are %1$s": [
    null,
    "A cota mínima é %1$s"
  ],
  "The minimum wager is %1$s": [
    null,
    "A aposta mínima é %1$s"
  ],
  "The odds have changed": [
    null,
    "A cotas foi alterada"
  ],
  "The prize for this collection has already been claimed": [
    null,
    ""
  ],
  "The remote-controlled ball with its unpredictable trajectories": [
    null,
    "A bola telecomandada e as suas trajetórias imprevisíveis"
  ],
  "The service is currently unavailable. We will restore this as soon as possible. We apologise for any inconveniences caused by this.": [
    null,
    "Serviço indisponível de momento. Será reposto com a maior brevidade possível. Lamentamos o incomodo causado."
  ],
  "The system grid is an expert mode. It allows you to create complex grids with some basic matches.": [
    null,
    "A grelha em sistema é um modo especialista. Esta permite criar grelhas complexas com algumas partidas de base. "
  ],
  "The video could not be loaded as it is an unsupported video format or due to a server issue.": [
    null,
    "O vídeo não pode ser carregado devido um formato não suportado ou erro do servidor."
  ],
  "This QR code is not a Winamax bonus code": [
    null,
    "Este código QR não é um código de bónus Winamax"
  ],
  "This broadcast is not available in your country of residence.": [
    null,
    "A transmissão deste vídeo não está autorizada no seu país"
  ],
  "This code is not a Winamax bonus code or has already been credited": [
    null,
    "Este código não é um código de bónus Winamax ou já foi utilizado"
  ],
  "This event is no longer available": [
    null,
    "Este evento já não se encontra disponível"
  ],
  "This free bet cannot be used": [
    null,
    "Esta free bet não pode ser utilizada "
  ],
  "This match is already included in the betslip you wish to enhance.": [
    null,
    "Este jogo já está incluído na aposta que desejas completar."
  ],
  "This promotion has ended": [
    null,
    "Esta promoção terminou"
  ],
  "This promotion will end in under 24 hours": [
    null,
    "Esta promoção irá terminar dentro de 24 horas"
  ],
  "This version of the software is not supported": [
    null,
    "Esta versão do software não é suportada"
  ],
  "This video could not be loaded as it has unsupported functionalities.": [
    null,
    "O vídeo não pode ser carregado devido a funcionalidades não suportadas."
  ],
  "Three-pointers": [
    null,
    "Triplos"
  ],
  "Tick the boxes in your grid.": [
    null,
    "Clique nas caixas na da sua grelha."
  ],
  "To be won": [
    null,
    "A ganhar"
  ],
  "Tomorrow": [
    null,
    "Amanhã"
  ],
  "Too many attempts.": [
    null,
    "Demasiadas tentativas."
  ],
  "Too many bankers": [
    null,
    "Demasiadas bases selecionadas"
  ],
  "Too many bets selected": [
    null,
    "Demasiadas apostas selecionadas"
  ],
  "Too many selections": [
    null,
    "Demasiadas apostas selecionadas"
  ],
  "Top competitions": [
    null,
    "Top competições"
  ],
  "Total": [
    null,
    "Total"
  ],
  "Total away": [
    null,
    "Total visitante"
  ],
  "Total home": [
    null,
    "Total em casa"
  ],
  "Total odds": [
    null,
    "Total cotas"
  ],
  "Total wager": [
    null,
    "Valor total apostado"
  ],
  "Total winnings": [
    null,
    "Total de ganhos"
  ],
  "Touchdowns scorers": [
    null,
    "Marcadores de touchdowns"
  ],
  "Triple-double": [
    null,
    "Triplo-duplo"
  ],
  "Try again": [
    null,
    "Tentar novamente"
  ],
  "Try scorer Duo": [
    null,
    "Dupla de Marcadores de ensaio"
  ],
  "Try scorer Trio": [
    null,
    "Trio de Marcadores de ensaio"
  ],
  "Try scorers": [
    null,
    "Marcadores de ensaios"
  ],
  "Try:": [
    null,
    "Experimentar:"
  ],
  "Turnovers": [
    null,
    "Turnovers"
  ],
  "Tutorial": [
    null,
    "Tutorial"
  ],
  "Type of goal scored by a team": [
    null,
    "Tipo de golo de uma equipa"
  ],
  "Unable to calculate odds": [
    null,
    "Não é possível calcular a cota"
  ],
  "Upcoming matches": [
    null,
    "Próximos jogos (calendário)"
  ],
  "Update": [
    null,
    "Atualizar"
  ],
  "Use Freebets": [
    null,
    "Usar apostas gratuitas"
  ],
  "Use a bonus": [
    null,
    "Utilizar um bónus"
  ],
  "Video unavailable": [
    null,
    "Vídeo indisponível"
  ],
  "View my bet": [
    null,
    "Ver a minha aposta"
  ],
  "View the most wagered bets in the last %1$s mins": [
    null,
    "Descobre as apostas mais populares nos últimos %1$s min"
  ],
  "View the most wagered bets in the last hour": [
    null,
    "Descobre as apostas mais populares na última hora"
  ],
  "Wager": [
    null,
    "Aposta"
  ],
  "Wager:": [
    null,
    "Valor apostado:"
  ],
  "Walkover": [
    null,
    ""
  ],
  "Want another accumulator? Switch to MyMatch!": [
    null,
    "Procuras outro resultado? Encontra-o no modo MyMatch!"
  ],
  "Want another multi-chance accumulator? Switch to MyMatch!": [
    null,
    "Procuras outro resultado multichance? Encontra-o no modo MyMatch!"
  ],
  "Want to check out all the promotions Winamax has to offer?": [
    null,
    "Queres conhecer todas as ofertas da Winamax?"
  ],
  "Warning:": [
    null,
    "Atenção:"
  ],
  "We were unable to generate your final image": [
    null,
    "Não foi possível criar a sua imagem final"
  ],
  "We'll explain everything step by step!": [
    null,
    "Vamos explicar-lhe tudo passo a passo!"
  ],
  "Welcome to the grid tutorial": [
    null,
    "Bem-vindo ao tutorial das grelhas"
  ],
  "Win a ton of Freebets along the way!": [
    null,
    "Ganhar o máximo de Freebets pelo caminho!"
  ],
  "Win all previous levels in order to unlock this level": [
    null,
    "Conclui os níveis anteriores para desbloqueares este nível"
  ],
  "Win up to": [
    null,
    "Ganhe até"
  ],
  "Win up to %1$s times your reference bet in Freebets!": [
    null,
    "Ganhe até %1$s vezes a sua aposta de referência em Freebets!"
  ],
  "WinaTV channel": [
    null,
    "Canal WinaTV"
  ],
  "Winamax QR code": [
    null,
    "Código QR Winamax"
  ],
  "Winamax grid": [
    null,
    "Grelha Winamax"
  ],
  "Winning is everything": [
    null,
    "O mais importante é ganhar"
  ],
  "Winnings": [
    null,
    "Ganhos"
  ],
  "Winnings %1$s": [
    null,
    "Ganhos %1$s"
  ],
  "Winnings inferior or equal to the wager": [
    null,
    "Ganhos inferiores ou iguais à aposta "
  ],
  "Won": [
    null,
    "Ganha"
  ],
  "Xmas": [
    null,
    ""
  ],
  "Yes": [
    null,
    "Sim"
  ],
  "You aborted the media playback.": [
    null,
    "Leitura de vídeo interrompida."
  ],
  "You are currently excluded from %1$s due to your game limits": [
    null,
    ""
  ],
  "You are currently excluded from Monopoly due to your game limits": [
    null,
    "Está atualmente excluído do Monopoly devido aos seus limites de jogo"
  ],
  "You are currently excluded from betting promotions in your %1$s": [
    null,
    "De momento encontra-se excluído das ofertas de apostas desportivas nos seus %1$s."
  ],
  "You are currently ineligible for %1$s": [
    null,
    ""
  ],
  "You are currently ineligible for Boom %1$s": [
    null,
    "Não é atualmente elegível para o Boom %1$s"
  ],
  "You are currently ineligible for Monopoly": [
    null,
    "Não é atualmente elegível para o Monopoly"
  ],
  "You are currently not eligible to betting promotions": [
    null,
    "De momento não é elegível às ofertas de apostas desportivas."
  ],
  "You are not authorized to connect from this country.": [
    null,
    "Não está autorizado a conectar-se a partir deste país."
  ],
  "You can also make doubles or triples to increase your chances of winning": [
    null,
    "Pode também fazer duplos ou triplos par aumentar as suas hipóteses de ganhar "
  ],
  "You can also select doubles and triples to have a better chance of winning.": [
    null,
    "Pode também selecionar duplos ou triplos para ter melhores hipóteses de ganhar. "
  ],
  "You can do so right here! :index_vers_le_bas:": [
    null,
    "Nesta página ficas a conhecer tudo, basta clicar aqui!"
  ],
  "You can select doubles and triples to increase your chances of winning.": [
    null,
    "Pode selecionar duplos ou triplos para aumentar as suas hipóteses de ganhar."
  ],
  "You cannot bet on this grid anymore": [
    null,
    "Já não pode apostar nesta grelha"
  ],
  "You cannot combine multiple bets on the same match": [
    null,
    "Não poder combinar múltiplas apostas no mesmo jogo."
  ],
  "You cannot combine these bets": [
    null,
    "Não poder combinar estas apostas "
  ],
  "You have already placed the same bet recently": [
    null,
    "Já realizou a mesma aposta recentemente"
  ],
  "You have already received your reward": [
    null,
    ""
  ],
  "You have been active for %1$s minutes now.": [
    null,
    "Já estás a jogar há %1$s minutos."
  ],
  "You have exceeded the maximum stake for this bet": [
    null,
    "Ultrapassou o montante máximo para esta aposta"
  ],
  "You have made a request to change your password. Please check your emails.": [
    null,
    "Realizou um pedido para alterar a sua palavra-passe. Por favor, verifique os seus emails."
  ],
  "You have no favourites": [
    null,
    "Não tem favoritos"
  ],
  "You have no funds in your account.": [
    null,
    "Não tem saldo na sua conta."
  ],
  "You lose": [
    null,
    ""
  ],
  "You may not receive a booster on this bet": [
    null,
    "Poderá não beneficiar do booster nesta aposta"
  ],
  "You must be logged": [
    null,
    "Tem de estar conectado"
  ],
  "You must be logged in to see this page": [
    null,
    "Tem de estar conectado para ver esta página"
  ],
  "You must be logged in to validate your bets": [
    null,
    "Deve estar conectado para validar as suas apostas"
  ],
  "You must be logged in to validate your grid.": [
    null,
    "Tem de estar conectado para validar a sua grelha."
  ],
  "You must be of majority age to play": [
    null,
    "Tem de ser maior de idade para jogar"
  ],
  "You must have a minimum of €1 on your account, or you must have placed a bet on this match.": [
    null,
    "Deverá ter no mínimo 1€ na sua conta, ou ter apostado nesta partida"
  ],
  "You must log in to %1$s in order to access your account.": [
    null,
    "Tem de fazer log in em %1$s de forma a aceder à sua conta."
  ],
  "You must select doubles or triples to make a team grid.": [
    null,
    "Tem de selecionar duplos ou triplos para fazer uma grelha em equipa."
  ],
  "You must tick at least one box per line.": [
    null,
    "Tem de validar pelo menos uma caixa por linha."
  ],
  "You must wager your deposit in order to withdraw it": [
    null,
    ""
  ],
  "You only have %1$s": [
    null,
    "Tem apenas %1$s"
  ],
  "You only have %1$s in Freebets available": [
    null,
    "Tem apenas %1$s em Freebets disponíveis "
  ],
  "You will earn between %1$s and %2$s times your reference bet in Freebets.": [
    null,
    ""
  ],
  "You will exceed your daily limit. The maximum wager is %1$s": [
    null,
    "Excedeu o seu limite diário. A aposta máxima é %1$s"
  ],
  "You will exceed your monthly limit. The maximum wager is %1$s": [
    null,
    "Excedeu o seu limite mensal. A aposta máxima é %1$s"
  ],
  "You will exceed your weekly limit. The maximum wager is %1$s": [
    null,
    "Excedeu o seu limite semanal. A aposta máxima é %1$s   "
  ],
  "You win": [
    null,
    "Ganha"
  ],
  "You win Freebets": [
    null,
    "Ganhou Freebets"
  ],
  "You won Freebets": [
    null,
    "Ganhou uma Freebet de"
  ],
  "You've already won everything!": [
    null,
    "Já ganhou todos os presentes!"
  ],
  "Your %1$s bet could not be cashed out": [
    null,
    "A sua aposta não pôde ser fechada"
  ],
  "Your %1$s bet has been validated": [
    null,
    "A sua %1$s aposta foi validadas"
  ],
  "Your %1$s bet was cashed out for %2$s": [
    null,
    "Fechou sua aposta %1$s por %2$s"
  ],
  "Your account is frozen.": [
    null,
    "A sua conta está congelada"
  ],
  "Your account is locked": [
    null,
    "A sua conta está bloqueada"
  ],
  "Your account is not authorized for use in this region": [
    null,
    "A sua conta não está autorizada a conectar-se nesta plataforma. "
  ],
  "Your app is out of date, please update to the latest version": [
    null,
    "A versão da sua aplicação está obsoleta. Por favor atualize-a."
  ],
  "Your betslip is empty!": [
    null,
    "O seu boletim está vazio!"
  ],
  "Your bonus code has been accepted": [
    null,
    "O seu código de bónus foi registado com sucesso"
  ],
  "Your email address has not been verified. Please check your emails.": [
    null,
    "O seu endereço email ainda não foi verificado. Por favor, verifique os seus emails."
  ],
  "Your grid has %1$s double": [
    "Your grid has %1$s doubles",
    "A sua grelha tem %1$s duplo ",
    "A sua grelha tem %1$s duplos "
  ],
  "Your grid has been validated.": [
    null,
    "A sua grelha foi validada"
  ],
  "Your grid will only be validated once it has been entirely financed.": [
    null,
    "A sua grelha será validada assim que for completamente financiada."
  ],
  "Your mission is simple:": [
    null,
    "A tua missão é simples:"
  ],
  "Your participation in the game has already been validated": [
    null,
    ""
  ],
  "Your turn to play!": [
    null,
    "É a sua vez de jogar!"
  ],
  "Your winning and ongoing bets already exceed the objective": [
    null,
    "As suas apostas ganhas e em curso já ultrapassam o objetivo"
  ],
  "Your winnings of %1$s will be credited to you as soon as all bets are settled.": [
    null,
    ""
  ],
  "abandoned": [
    null,
    "Abandonou"
  ],
  "already received": [
    null,
    "Já recebido"
  ],
  "and %1$s triple": [
    "and %1$s triples",
    "e %1$s triplo",
    "e %1$s triplos"
  ],
  "break": [
    null,
    "Intervalo"
  ],
  "collected": [
    null,
    "recolhido"
  ],
  "delayed": [
    null,
    "Atrasado"
  ],
  "events in progress": [
    null,
    "Eventos a decorrer"
  ],
  "extra innings": [
    null,
    "inning extra"
  ],
  "extra-time": [
    null,
    "Prolongamento"
  ],
  "extra-time - 1st half": [
    null,
    "Prolongamento - 1ª parte"
  ],
  "extra-time - 2nd half": [
    null,
    "Prolongamento - 2ª parte"
  ],
  "extra-time finished": [
    null,
    "Prolongamento terminado"
  ],
  "extra-time half-time": [
    null,
    "Prolongamento - Intervalo"
  ],
  "extra-time will begin": [
    null,
    "Início do prolongamento"
  ],
  "free": [
    null,
    "gratuitas"
  ],
  "gaming limits": [
    null,
    "limites de jogo"
  ],
  "golden set": [
    null,
    "golden set"
  ],
  "grid %1$s n°%2$s": [
    null,
    "Grelha%1$s n: %2$s"
  ],
  "grids": [
    null,
    "grelhas"
  ],
  "guaranteed": [
    null,
    "garantido"
  ],
  "half-time": [
    null,
    "Intervalo"
  ],
  "handicap format": [
    null,
    "formato handicap"
  ],
  "how it works": [
    null,
    "como funciona"
  ],
  "in progress": [
    null,
    "a decorrer"
  ],
  "including %1$s:": [
    null,
    "Incluindo %1$s:"
  ],
  "including rank 1 deferral:": [
    null,
    "Incluindo adiamento de primeiro nível:"
  ],
  "match abandoned": [
    null,
    "Partida abandonada"
  ],
  "match delayed": [
    null,
    "Partida adiada"
  ],
  "match finished": [
    null,
    "Partida terminada"
  ],
  "match in progress": [
    null,
    "Partida a decorrer"
  ],
  "match interrupted": [
    null,
    "Partida interrompida"
  ],
  "match interuppted": [
    null,
    "Parida interrompida"
  ],
  "match postponed": [
    null,
    "Partida adiada"
  ],
  "match started": [
    null,
    "Partida a decorer"
  ],
  "missions:AlreadyOpted": [
    null,
    "Inscrito"
  ],
  "missions:Log in": [
    null,
    "Login"
  ],
  "missions:Opt in": [
    null,
    "Inscrever-me"
  ],
  "most popular": [
    null,
    "mais apostados"
  ],
  "no events": [
    null,
    "sem eventos"
  ],
  "n°": [
    null,
    "n°"
  ],
  "of the base": [
    "of %1$s bases",
    "da base",
    "de %1$s bases"
  ],
  "ok": [
    null,
    "ok"
  ],
  "or": [
    null,
    "ou"
  ],
  "overtime": [
    null,
    "Prolongamento"
  ],
  "overtime finished": [
    null,
    "Prolongamento terminado"
  ],
  "overtime will begin": [
    null,
    "O prolongamento vai começar"
  ],
  "own goal": [
    null,
    "autogolo"
  ],
  "pause": [
    null,
    "pausa"
  ],
  "penalty": [
    null,
    "penálti"
  ],
  "penalty shoot-out": [
    null,
    "Grandes penalidades"
  ],
  "retired": [
    null,
    "Abandonou"
  ],
  "selection": [
    "selections",
    "seleções",
    "seleção"
  ],
  "session break": [
    null,
    "Intervalo da temporada"
  ],
  "sudden death": [
    null,
    "Morte súbita"
  ],
  "text format": [
    null,
    "formato texto"
  ],
  "the 2nd quarter will begin": [
    null,
    "O 2º quarto vai começar "
  ],
  "the 2nd set will begin": [
    null,
    "O 2º set vai começar"
  ],
  "the 3rd quarter will begin": [
    null,
    "O 3º quarto vai começar"
  ],
  "the 3rd set will begin": [
    null,
    "O 3º set vai começar"
  ],
  "the 4th quarter will begin": [
    null,
    "O 4º quarto vai começar "
  ],
  "the 4th set will begin": [
    null,
    "O 4º set vai começar"
  ],
  "the 5th set will begin": [
    null,
    "O 5º set vai começar"
  ],
  "the Gift Race": [
    null,
    ""
  ],
  "timer:d": [
    null,
    "d"
  ],
  "timer:finished": [
    null,
    "Terminadas"
  ],
  "timer:h": [
    null,
    "h"
  ],
  "timer:min": [
    null,
    "min"
  ],
  "up to": [
    null,
    "até"
  ],
  "walkover": [
    null,
    "Retirado"
  ],
  "with your next deposit": [
    null,
    "com o seu próximo depósito"
  ]
}
  }
}
